module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAACwAAAAsCAYAAAAehFoBAAAACXBIWXMAAAsSAAALEgHS3X78AAAAs0lEQVRYhe3YsQ3DIBCF4XPkDdgBFqRhBraBHZgBhnBNeRFRBsAmz0mk90nuMPfLcoHYVFVWhRDUGDO1i/d+Wxo3gleflJKesDTvsfx5b8ZgNAajMRiNwWgMRmMwGoPhYoxnzrJfVWtV/hJoDEZjMBqD0f4ueD+OQ3LOS5tYa8U5N7W2lCJj5hWv9+6+qnofBXhV9bMYjMZgNAajMRiNwWgMRts/sf84p7bWptb23q8PEpEn2ybldqimc0oAAAAASUVORK5CYII="


//////////////////
// WEBPACK FOOTER
// ./src/Images/OldCampIcons/007.png
// module id = 1017
// module chunks = 0